/** @format */

export function getMoveable(type = null) {
  return type ? type == this.state?.moveable : this.state?.moveable || null;
}

export function setMoveable(type) {
  this.setState({ moveable: type });
}
